import React, { useState, useEffect } from "react";
import injectSheet, { withTheme } from "react-jss";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import * as _ from "lodash";
import Addmenu from "../NavMenus/Addmenu";
import Editmenu from "../NavMenus/Editmenu";
import Statusmenu from "../NavMenus/Statusmenu";
import { ViewType } from "../../../utils/Enums";
import Icon from "../../../assets/icons/Icon";
import FixedBackground from "../../../utils/Helpers/FixedBackground";
import HelpNavItem from "../HelpNavItem.js";

const NavMenuMobile = ({
  classes,
  userState,
  visible,
  logout,
  toggleMobileMenu,
  theme
}) => {
  const [visibles, setVisibles] = useState([true, false, false]);
  const [dontShowAddKonto, setDontShowAddKonton] = useState(false);
  const [elements, setElements] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(userState.user)) {
      setDontShowAddKonton(
        userState.user.avdelnings.every((x) => !x.internalUser)
      );
      const hasSkapaPermission =
        userState.user.allViews.filter((view) => view === ViewType.AttSkapa)
          .length > 0;
      let tempElements = [];
      if (hasSkapaPermission)
        tempElements.push({
          header: "Skapa arrangemang",
          component: <Addmenu hideHeader toggleMobileMenu={toggleMobileMenu} />,
        });
      tempElements.push({
        header: "Hantera",
        component: <Editmenu hideHeader toggleMobileMenu={toggleMobileMenu} />,
      });
      tempElements.push({
        header: "Visa",
        component: (
          <Statusmenu hideHeader toggleMobileMenu={toggleMobileMenu} />
        ),
      });
      setElements(tempElements);
    }
  }, [userState]);

  const showHide = (e) => {
    setVisibles(
      visibles.map((header, index) =>
        index === Number(e.currentTarget.value) && !header ? true : false
      )
    );
  };

  return (
    <div>
      {visible && <FixedBackground onClick={() => toggleMobileMenu()} />}
      <div
        className={classNames(
          classes.navmenu,
          visible && classes.navmenuVisible
        )}
      >
        <div className={classes.innerWrapper}>
          <div className={classes.close}>
            <button onClick={toggleMobileMenu} value="-1">
              <Icon type="clear" fill="white" width="24px" />
            </button>
          </div>
          {elements.map((element, index) => (
            <div
              key={index}
              className={classes.flexContainer}
              style={
                visibles[index]
                  ? {
                      backgroundColor: theme.menuMobileSelectedColor,
                    } // "rgb(39,55,93)" }
                  : null
              }
            >
              <button
                className={classes.collapseButton}
                value={index}
                onClick={showHide}
              >
                <div className={classes.flex}>
                  <div className={classes.header}>{element.header}</div>
                  <div>
                    <Icon
                      type="arrow"
                      fill="white"
                      width="16px"
                      rotate={visibles[index] ? "90" : "-90"}
                    />
                  </div>
                </div>
              </button>
              {visible && (
                <div className={classes.componentContainer}>
                  {!visibles[index] ? null : element.component}
                </div>
              )}
            </div>
          ))}
          <div className={classes.bottomContainer}>
            <div className={classes.flexNoJustify}>
              <HelpNavItem iconSize="24px" />
            </div>
            {!dontShowAddKonto && (
              <NavLink
                onClick={toggleMobileMenu}
                title="Konton"
                to="/kontohantering"
              >
                <div className={classes.flexNoJustify}>
                  <Icon type="konton" fill="white" width="24px" />
                  <span className={classes.label}>Konton</span>
                </div>
              </NavLink>
            )}
            <NavLink
              onClick={toggleMobileMenu}
              title="Inställningar"
              to="/min-sida"
            >
              <div className={classes.flexNoJustify}>
                <Icon type="settings" fill="white" width="24px" />
                <span className={classes.label}>
                  {userState?.user?.fornamn}
                </span>
              </div>
            </NavLink>
            <button
              style={{ marginBottom: "100px" }}
              onClick={logout}
              title="Logga ut"
            >
              <div className={classes.flexNoJustify}>
                <Icon type="logoff" fill="white" width="24px" />
                <span className={classes.label}>Logga ut</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const styles = (theme) => ({
  navmenu: {
    height: "100vh",
    backgroundColor: theme.menuDarkColor, //"#182d58",
    transition: "width .45s ease",
    width: "0",
    right: "0",
    top: "0",
    position: "fixed",
    zIndex: 1000,
  },
  innerWrapper: {
    position: "absolute",
    overflowX: "auto",
    width: "100%",
    height: "100vh",
  },
  navmenuVisible: {
    width: "calc(100% - 56px)",
  },
  close: {
    textAlign: "right",
    "& button": {
      border: "0",
      cursor: "pointer",
      padding: "16px 18px 16px 16px",
      backgroundColor: "transparent",
    },
  },
  label: {
    paddingLeft: "16px",
    fontSize: "16px",
    color: "white",
    fontWeight: "normal",
  },
  flexContainer: {
    "& ul": {
      margin: "0",
      padding: "0",
    },
  },
  collapseButton: {
    padding: "16px 22px 16px 24px",
    backgroundColor: "transparent",
    border: "0",
    outline: "0",
    width: "100%",
    cursor: "pointer",
    borderTop: "1px solid rgba(255, 255, 255, 0.15)",
  },
  flex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexNoJustify: {
    display: "flex",
    alignItems: "center",
    "& > svg g polygon": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "& >svg path, circle, rect": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
  },
  componentContainer: {
    padding: "0 16px",
  },
  header: {
    color: "white",
    padding: "7px 0",
    textTransform: "uppercase",
    fontSize: "14px",
    fontWeight: "500",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "1.14",
    letterSpacing: "0.5px",
  },
  bottomContainer: {
    borderTop: "1px solid rgba(255, 255, 255, 0.15)",
    padding: "45px 24px",
    "& > button, & a": {
      width: "100%",
      display: "block",
      border: "0",
      cursor: "pointer",
      backgroundColor: "transparent",
      textAlign: "left",
      padding: "8px 0",
      marginBottom: "8px",
      "& span": { color: "white" },
    },
  },
  "@media (min-width:1270px)": {
    navmenu: { display: "none" },
  },
  "@media (max-width: 767px)": {
    bottomContainer: {
      padding: "15px 24px",
    },
  },
});
export default injectSheet(styles)(withTheme(NavMenuMobile));
